// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"258":"23d631f5","679":"f16f1ab9"}[chunkId] + ".chunk.css";
};